<template>
  <div :style="stackWrapperStyle" :class="stacked ? 'stacked-wrap' : ''">
    <BaseTooltip :disabled="false">
      <template v-slot:content>
        <span v-if="stacked" class="fa-stack help-stack" :alvqa="alvqa" @click="openContextHelp">
          <i class="fa fa-circle fa-stack-1x help-bg"></i>
          <i class="fa fa-question-circle fa-stack-1x help-fg"></i>
        </span>
        <BaseIcon
          v-else
          icon="fa-question-circle"
          small
          :color="color"
          :tooltipText="$t('lang_GENERIC_CAPTION_CONTEXT_HELP')"
          @click="openContextHelp"
          :alvqa="alvqa"
        />
      </template>
      <template v-slot:text>
        {{ $t('lang_GENERIC_CAPTION_CONTEXT_HELP') }}
      </template>
    </BaseTooltip>
  </div>
</template>

<script>
import BaseIcon from '@/components/_buttons/BaseIcon.vue'
import BaseTooltip from '@/components/_base/BaseTooltip'

export default {
  name: 'ContextHelpIcon',
  components: { BaseIcon, BaseTooltip },
  props: {
    context: { type: String, required: true },
    section: { type: String, default: null },
    panelTitle: { type: String, default: null },
    alvqa: { type: String, default: 'context-help-icon' },
    color: { type: String, default: 'iconContextHelp' },
    // Stacked (FA) ring options
    stacked: { type: Boolean, default: true },
    stackBgColor: { type: String, default: '#ffffff' },
    ringScale: { type: Number, default: 1.08 },
    yOffset: { type: Number, default: 0 }
  },
  computed: {
    stackWrapperStyle() {
      if (!this.stacked) return null
      return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        transform: this.yOffset ? `translateY(${this.yOffset}px)` : undefined
      }
    }
  },
  methods: {
    openContextHelp() {
      this.hideActiveTooltips()
      this.$store.commit('setContextHelpDialog', {
        show: true,
        context: this.context,
        section: this.section,
        panelTitle: this.panelTitle
      })
    },
    hideActiveTooltips() {
      const activeTooltips = document.querySelectorAll('.v-tooltip__content[style*="opacity: 1"]')
      activeTooltips.forEach(tooltip => {
        tooltip.style.opacity = '0'
        tooltip.style.pointerEvents = 'none'
      })
    }
  }
}
</script>

<style scoped>
/* Wrapper size for stacked variant */
.stacked-wrap .help-stack {
  width: 24px;
  height: 24px;
  line-height: 24px;
  font-size: 18px; /* foreground icon size baseline */
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
/* Background circle, slightly scaled to create ~1px ring */
.stacked-wrap .help-bg {
  color: #ffffff !important;
  transform: scale(var(--ring-scale, 1.08));
}
/* Foreground help icon, use theme variable for color */
.stacked-wrap .help-fg {
  color: var(--v-iconContextHelp-base) !important;
}
</style> 